// src/pages/Services.jsx
import React from "react";
import ServicesHeader from "../components/booking/ServicesHeader";
import BookingSection from "../components/booking/BookingSection";
// import ContactInfo from "../components/booking/ContactInfo";

const Bookings = () => {
  const pageStyle = {
    paddingTop: "100px",
    minHeight: "100vh",
    backgroundColor: "#f5f5f5",
    display: "flex",
    flexDirection: "column",
  };

  const bookingSectionStyle = {
    flex: "1", // This makes it take up remaining space
  };

  return (
    <div style={pageStyle}>
      <ServicesHeader />
      <div style={bookingSectionStyle}>
        <BookingSection />
      </div>
      {/* <ContactInfo /> */}
    </div>
  );
};

export default Bookings;
